import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Grid2 as Grid,
  Typography,
  Container,
  Box,
} from "@mui/material";
import { ParticipantData } from "../../models/Participant";
import participantService from "../../services/participantService";

//pass in the participant id as a prop
interface EditParticipantProps {
  participantId: string;
  onClose: (success: boolean) => void;
}

const EditParticipant: React.FC<EditParticipantProps> = ({
  participantId,
  onClose,
}) => {
  const [participant, setParticipant] = useState<ParticipantData | null>(null);

  useEffect(() => {
    // Fetch participant data
    // This is a placeholder. You'll need to implement a function to fetch a single participant
    const fetchParticipant = async () => {
      const data = await participantService.getParticipantById(participantId);
      setParticipant(data);
    };
    fetchParticipant();
  }, [participantId]);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (participant) {
      try {
        await participantService.editParticipant(participantId, participant);
        onClose(true);
      } catch (error) {
        console.error("Failed to update participant:", error);
      }
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setParticipant((prev) => (prev ? { ...prev, [name]: value } : null));
  };

  if (!participant) return <Typography>Loading...</Typography>;

  return (
    <Container maxWidth="sm">
      <Typography variant="h4" component="h1" gutterBottom>
        Edit Participant {participant.firstName} {participant.lastName}
      </Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 6 }}>
            <TextField
              fullWidth
              label="First Name"
              name="firstName"
              value={participant.firstName}
              onChange={handleChange}
              required
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <TextField
              fullWidth
              label="Last Name"
              name="lastName"
              value={participant.lastName}
              onChange={handleChange}
              required
            />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <TextField
              fullWidth
              label="Email"
              name="email"
              type="email"
              value={participant.email}
              onChange={handleChange}
              required
            />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <TextField
              fullWidth
              label="Organization"
              name="organization"
              value={participant.organization}
              onChange={handleChange}
              required
            />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <TextField
              fullWidth
              label="Position/Title"
              name="positionTitle"
              value={participant.positionTitle}
              onChange={handleChange}
              required
            />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <TextField
              fullWidth
              label="Phone Number"
              name="phoneNumber"
              value={participant.phoneNumber}
              onChange={handleChange}
              required
            />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <TextField
              fullWidth
              label="Address"
              name="address"
              value={participant.address}
              onChange={handleChange}
              required
            />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <Button
              onClick={() => onClose(false)}
              variant="outlined"
              sx={{ marginRight: "10px" }}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              sx={{ marginRight: "10px" }}
            >
              Update Participant
            </Button>
          </Grid>
        </Grid>
      </form>
    </Container>
  );
};

export default EditParticipant;
